<template>
  <form
    role="form"
    method="POST"
    action="/registrace-role"
    class="onboarding-form"
    @submit.prevent="submit"
    novalidate
  >
    <div class="onboarding-navbar">
      <span>
        5/5
      </span>
    </div>

    <div id="bar" class="progress">
      <div
        class="progress-bar"
        role="progressbar"
        aria-valuenow="100%"
        aria-valuemin="0"
        aria-valuemax="100"
        style="width: 100%;"
      ></div>
    </div>

    <div class="container">
      <!-- Tab panes -->
      <div class="tab-content">
        <slot></slot>

        <div class="onboarding-tab tab-pane slide-5 active valid" id="tab-5">
          <div class="form">
            <header>
              <h2 class="tab-title no-ml">{{ __('Complete your registration') }}</h2>
            </header>

            <div class="tab-inputgroup">
              <FormInputTypeAvatarImageSelect name="avatar" />

              <form-input-type-radio
                  name="sex"
                  :options="[
                    {value: 'f', label: __('Woman')},
                    {value: 'm', label: __('Man')}
                  ]"
                  margin-bottom-double
                  required
              ></form-input-type-radio>

              <form-input-type-text
                  name="name"
                  :label="__('First name')"
                  :errors="errors.name"
                  margin-bottom-double
                  required
              ></form-input-type-text>

              <form-input-type-text
                  name="surname"
                  :label="__('Last name')"
                  :errors="errors.surname"
                  margin-bottom-double
                  required
              ></form-input-type-text>

              <form-input-type-email
                  name="email"
                  :label="__('E-mail')"
                  :errors="errors.email"
                  margin-bottom-double
                  required
              ></form-input-type-email>

              <!-- <div :class="['input-wrapper input-phone', { 'has-error': errors.phone }]">
                <select id="phone_country" name="phone_country">
                  <option v-for="country_code in country_codes" :value="country_code.country" :key="country_code.country" class="country-option" :data-title="__( country_code['title'])">
                    {{ country_code.code }}
                  </option>
                </select>
                <label for="phone">{{ __('Phone number') }}</label>
                <input id="phone" type="text" :placeholder="__('Phone number')" name="phone" required />
                <template v-if="errors.phone">
                  <span class="help-block">
                    <strong>{{ errors.phone[0] }}</strong>
                  </span>
                </template>
                <p>{{ __('We need a phone number as a second option to contact your dietitian.') }}</p>
              </div> -->

              <form-input-type-password 
                name="password"
                :label="__('Password')"
                :errors="errors.password"
                :note="__('The password must contain at least 10 characters and at least one upper and one lower case letter.')"
                margin-bottom-double
                required
              ></form-input-type-password>

              <form-input-type-text
                  name="role"
                  :label="__('Role')+' ('+__('mandatory')+') - coach_admin/sales_rep'"
                  :errors="errors.role"
                  margin-bottom-double
                  required
              ></form-input-type-text>

              <form-input-type-select
                  name="institution_id"
                  :label="__('Institution')"
                  :options="institutionList"
                  :errors="errors.institution_id"
                  margin-bottom-double
              ></form-input-type-select>

              <form-input-type-text
                  name="country"
                  :label="__('Země')"
                  :errors="errors.role"
                  margin-bottom-double
                  required
              ></form-input-type-text>
            </div>
          </div>
        </div>

        <ul class="onboarding-pager">
          <li class="previous">
            <a class="btn btn-prev btn-cons" href="">
              <figure>
                <!-- TODO extract svg -->
                <svg
                  width="16px"
                  height="17px"
                  viewBox="0 0 16 17"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <g
                    id="Android-APP-wireframes"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g
                      id="login-prihlaseni"
                      transform="translate(-20.000000, -44.000000)"
                      fill="#5937B7"
                    >
                      <g id="Top-Bar/Back">
                        <g id="Top-Bar/Back-Icon">
                          <polygon
                            id="back-arrow"
                            points="36 51.20625 23.8 51.20625 29.4 45.50125 28 44.075 20 52.225 28 60.375 29.4 58.94875 23.8 53.24375 36 53.24375"
                          ></polygon>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </figure>
            </a>
          </li>

          <li class="next">
            <v-button :label="__('Create an account')" type="submit" position="center" size="lg" class="btn-next" />
          </li>
        </ul>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    institutions: Object
  },
  data() {
    return {
      errors: {},
      institutionList: []
    }
  },
  mounted() {
    $('#register-form').animate({ opacity: 1 }, 300)

    Object.values(this.institutions).map((institution, index) => {
      this.institutionList.push(
        {
          value: institution.id,
          label: institution.name,
          img: institution.icon
        }
      )
    });
  },
  methods: {
    submit() {
      let data = new FormData(this.$el)

      axios
        .post('registrace-role', data)
        .then(() => window.location.replace('/pacienti'))
        .catch((e) => {
          this.errors = e.response.data.errors
        })
    },
  }
}
</script>
